module.exports = __webpack_public_path__ + "static/image/history/m/202208@3x.ver2_0_2.jpg?cc11ffc9";